__turbopack_context__.v({
  "btn": "CartOrderSummary-module-scss-module__dtIWYW__btn",
  "cart": "CartOrderSummary-module-scss-module__dtIWYW__cart",
  "cartHeader": "CartOrderSummary-module-scss-module__dtIWYW__cartHeader",
  "cartSummary": "CartOrderSummary-module-scss-module__dtIWYW__cartSummary",
  "cartWrap": "CartOrderSummary-module-scss-module__dtIWYW__cartWrap",
  "loading": "CartOrderSummary-module-scss-module__dtIWYW__loading",
  "row": "CartOrderSummary-module-scss-module__dtIWYW__row",
  "selected": "CartOrderSummary-module-scss-module__dtIWYW__selected",
  "total": "CartOrderSummary-module-scss-module__dtIWYW__total",
  "visuallyHidden": "CartOrderSummary-module-scss-module__dtIWYW__visuallyHidden",
});
